import { createAction, props } from "@ngrx/store";
import {
  RoomBrandLogoDeferredErrorVO,
  RoomBrandLogoDeleteEventVO,
  RoomBrandLogoSetEventVO
} from "@youm-front/room/domain";

export const roomBrandLogoSetEvent = createAction(
  "[Room] Room Brand Logo Set Event",
  props<{ roomBrandLogoSetEventVO: RoomBrandLogoSetEventVO }>()
);

export const roomBrandLogoDeleteEvent = createAction(
  "[Room] Room Brand Logo Delete Event",
  props<{ roomBrandLogoDeleteEventVO: RoomBrandLogoDeleteEventVO }>()
);

export const roomBrandLogoDeferredErrorEvent = createAction(
  "[Room] Room Brand Logo Deferred Error Event",
  props<{
    roomBrandLogoDeferredErrorVO: RoomBrandLogoDeferredErrorVO;
  }>()
);
